
<div class="card card-statistics mb-30" >
  <div class="card-body">
    <h5 class="card-title">فرم اطلاعات مرخصی ساعتی</h5>
    <form>


      <div class="row">
        <div class="form-group col-md-4">
          <label for="exampleInputEmail1"> ساعت شروع </label>
          <input disabled type="text" value="{{startTime_fulldate}}" class="form-control" placeholder="اینجا تایپ کنید ...">
        </div>

        <div class="form-group col-md-4">
          <label for="exampleInputEmail1"> ساعت پایان </label>
          <input disabled type="text" value="{{endTime_fulldate}}" class="form-control" placeholder="اینجا تایپ کنید ...">
        </div>

        <div class="form-group col-md-4">
          <label for="exampleInputEmail1"> تاریخ مرخصی </label>
          <input disabled type="text" value="{{requestDate}}" class="form-control" placeholder="اینجا تایپ کنید ...">
        </div>

      </div>

      <div class="row">
        <div class="form-group col-md-12">
          <label for="exampleInputEmail1"> شرح </label>
          <input disabled type="text" value="{{dsc}}" class="form-control" placeholder="اینجا تایپ کنید ...">
        </div>
      </div>
    </form>
  </div>
</div>